import React from "react";
import ReactDOM from "react-dom";
import UIManifest from "src/engine/ui/UIManifest";
import BaseUI, { IBaseUI } from "src/engine/ui/BaseUI";
// const QRcode = require("qrcodejs2");
const QRcode = require("qrcode-react");

interface IQRCode extends IBaseUI {
    className?: string;
    text: string;
    colorDark?: string;
    colorLight?: string;
    height?: number;
    width?: number;
    level?: string; //废弃
    style?: any;
    logo?: string;
    logoStyle?: any;
    toImage?: boolean;
}

@UIManifest.declareGG(["ggValue"], "QRCode", "QRCode组件")
export default class QRCode extends BaseUI<IQRCode> {
    qrcode: any;

    state = {
        imgData: "",
    };

    dom: any;

    static defaultProps = {
        text: "your content",
        colorDark: "#000000",
        colorLight: "#FFFFFF",
    };
    getSize = (style: any, ele: string, defaultvalue: number) => {
        // let { fontSize = '' } = style as any;
        // fontSize = fontSize.replace('px', '');
        return style && style[ele] ? style[ele].replace("rem", "").replace("px", "") : defaultvalue;
    };

    convertCanvasToImage() {
        const canvas: HTMLCanvasElement = ReactDOM.findDOMNode(this.qrCode?.current) as any;

        console.log("[QRCode]", "ssss", canvas);
        if (!canvas) return;

        //新建Image对象
        // canvas.toDataURL 返回的是一串Base64编码的URL
        const imgData = canvas.toDataURL("image/png");

        console.log("[QRCode]", "ssss", canvas, imgData);
        this.setState({ imgData });
    }

    qrCode: React.RefObject<HTMLCanvasElement> = React.createRef();

    componentDidMount() {
        /**  */
        const { toImage = false } = this.props;
        toImage && this.convertCanvasToImage();
    }

    render() {
        const { logoStyle, logo, text, colorDark, colorLight, style = {} } = this.props;
        const { imgData = "" } = this.state;
        const has = imgData.length > 0;
        return (
            <div>
                {has ? (
                    <img style={this.getStyle()} src={this.state.imgData} />
                ) : (
                    <QRcode
                        ref={this.qrCode}
                        size={this.getSize(style, "width", 128) || this.getSize(style, "height", 128)}
                        value={text}
                        logo={logo}
                        logoWidth={this.getSize(logoStyle, "width", 50)}
                        logoHeight={this.getSize(logoStyle, "height", 50)}
                        fgColor={colorDark}
                        bgColor={colorLight}
                    />
                )}
            </div>
        );
    }
}
